module.exports = __webpack_public_path__ + "static/img/icon_fz.9a5e333.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/icon_fz.png
// module id = lFBj
// module chunks = 1 3